import { FC } from 'react'
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material'
// import { useIntl } from 'react-intl'

const ProtocolItems: FC<{
  items: {
    id: number
    itemType: {
      id: number
      name: string
    }
    quantity: number
  }[]
}> = ({ items }) => {
  // const { formatMessage } = useIntl()

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700 }}>Nazwa</TableCell>
            <TableCell sx={{ fontWeight: 700 }} align='right'>Ilość</TableCell>
          </TableRow>
        </TableHead>
        <TableBody></TableBody>
        {items.map((item) => (
          <TableRow key={item.id}>
            <TableCell component='th' scope='row'>
              {item.itemType.name}
            </TableCell>
            <TableCell align='right'>{item.quantity}</TableCell>
          </TableRow>
        ))}
      </Table>
    </TableContainer>
  )
}

export default ProtocolItems
